enum Theme {
  Light = 'light',
  Dark = 'dark',
}

export default Theme;
